export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.654 4.504A3 3 0 0120.5 7.5V19a3 3 0 01-3 3h-11a3 3 0 01-3-3V7.5a3 3 0 013-3h11l.154.004zM5.5 19a1 1 0 001 1h11a1 1 0 001-1v-1h-13v1zm1-12.5a1 1 0 00-1 1V16h13V7.5a1 1 0 00-.898-.995L17.5 6.5h-11z\" fill=\"#7B61FF\"/><path d=\"M12 .375c1.323 0 2.727.438 3.707 1.418l-1.414 1.414c-.52-.52-1.366-.832-2.293-.832s-1.773.312-2.293.832L8.293 1.793C9.273.813 10.677.375 12 .375z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};